import React from 'react';
import T from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

// styles
import styles from './StepTitle.mod.css';
import classnames from 'classnames/bind';

const cn = classnames.bind(styles);

const StepTitle = ({ title, description }) => (
  <div className={cn('wrapper')}>
    <h2 className={cn({ 'has-description': description })}>{title}</h2>
    {description && (
      <h4 className={cn('description')}>{ReactHtmlParser(description)}</h4>
    )}
  </div>
);

StepTitle.propTypes = {
  title: T.string.isRequired,
  description: T.string
};

export default StepTitle;



// WEBPACK FOOTER //
// ./src/containers/Module/components/StepTitle.jsx